// Generated from legacy db.ts to keep files under 500 lines.
import { sql } from "../../base";
import type { User } from "../../types";

const usersModule = {
  // FIND USER BY AUTHENTICATION ID - Looks up a user by their Stack Auth ID
  // This is used during login to find the user's database record
  async findByStackAuthId(stackAuthId: string): Promise<User | null> {
    const result = await sql`
      SELECT * FROM users WHERE stack_auth_id = ${stackAuthId} LIMIT 1  -- Find user by their auth system ID
    `;
    return (result[0] as User) || null;  // Return user record or null if not found
  },
  
  // FIND USER BY DATABASE ID - Looks up a user by their internal database ID
  // This is used throughout the app to get user information
  async findById(id: string): Promise<User | null> {
    try {
      const result = await sql`
        SELECT * FROM users WHERE id = ${id} LIMIT 1  -- Find user by database ID
      `;
      return (result[0] as User) || null;  // Return user record or null if not found
    } catch (error) {
      console.error('Error fetching user by id:', error);  // Log any database errors
      return null;
    }
  },
  
  async create(stackAuthId: string, email?: string): Promise<User> {
    // Use ON CONFLICT to handle race conditions when multiple components
    // try to create the same user simultaneously
    const result = await sql`
      INSERT INTO users (stack_auth_id, email)
      VALUES (${stackAuthId}, ${email})
      ON CONFLICT (stack_auth_id) 
      DO UPDATE SET 
        email = COALESCE(EXCLUDED.email, users.email),
        updated_at = now()
      RETURNING *
    `;
    return result[0] as User;
  },
  
  async update(id: string, data: Partial<User>): Promise<User> {
    const result = await sql`
      UPDATE users
      SET email = COALESCE(${data.email}, email),
          display_name = COALESCE(${data.display_name}, display_name),
          profile_photo_url = COALESCE(${data.profile_photo_url}, profile_photo_url),
          bio = COALESCE(${data.bio}, bio),
          updated_at = now()
      WHERE id = ${id}
      RETURNING *
    `;
    return result[0] as User;
  }
};

export type UsersModule = typeof usersModule;

export function registerUsers(db: { users?: UsersModule }) {
  db.users = usersModule;
}

export { usersModule as users };
